import svg from "./function-icon.svg?react";
import { makeSvgIcon } from "./svg-icon";

export const FunctionIcon = makeSvgIcon(svg);

export default FunctionIcon;
